export default [
  { text: 'ID', value: 'id' },
  { text: 'Full Name', value: 'fullName' },
  { text: 'Initials', value: 'initials' },
  { text: 'Email', value: 'email' },
  { text: 'Role', value: 'role' },
  { text: 'Created At', value: 'createdAt' },
  { text: 'Updated At', value: 'updatedAt' },
  { text: '', value: 'actions' }
];
